/**
 * @generated SignedSource<<557032d3ef879f5067a73e7d3a1e7322>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
export enum BillingSourceSystem {
  CCP = "CCP",
  HAMS = "HAMS",
}
export type useGetTenantDataFromCGraphQLQuery_license_License = {
  __typename?: "License";
  billingSourceSystem: BillingSourceSystem | null;
  trialEndDate: string | null;
  firstPredunningEndTime: number | null;
};
export type useGetTenantDataFromCGraphQLQuery_Query = {
  __typename?: "Query";
  license: useGetTenantDataFromCGraphQLQuery_license_License | null;
};
export type useGetTenantDataFromCGraphQLQueryVariables = Exact<{
  [key: string]: never;
}>;
export type useGetTenantDataFromCGraphQLQuery =
  useGetTenantDataFromCGraphQLQuery_Query;
